module.exports = __webpack_public_path__ + "static/media/code2.4ca6357e.jpg";